/* eslint-disable react-hooks/exhaustive-deps */
import React, { useContext, useState, useEffect } from "react";
import { Link } from "react-router-dom";
import profilePhoto from "../../assets/profile_photo.svg";
import { ReactComponent as LinkIcon } from "../../assets/link-icon.svg";
import { APIContext } from "../../api/api";
import HelmetLayout from "../../components/HelmetLayout";
import {toast} from "react-toastify";
import {promiseAllInBatches} from "../../utils";
import { PulseLoader } from "react-spinners";

function Templates() {
  const [templateList, setTemplateList] = useState();
  const [loading, setLoading] = useState(true);

  const { listOfAllTemplates } = useContext(APIContext);

  useEffect(() => {
    listOfAllTemplates()
      .then((template) => {
        console.log(template)
        setTemplateList(template);
        setLoading(false);
      })
      .catch((error) => {
        console.log(error.message);
      });
  }, []);


  return (
    <>
      <HelmetLayout title="Templates" />
      {loading ? (
        <div className="flex justify-center items-center h-screen">
          <PulseLoader color="#3B82F6" size={15} />
        </div>
      ) : (
        <div className="flex flex-col justify-start items-start w-full h-full">
          <div className="flex flex-col justify-start items-start w-full px-16 py-8">
            {/* Header Section */}
            <div className="flex flex-row justify-between items-center w-full">
              <div className="flex flex-row justify-start items-center gap-4">
                <img
                  className="w-12 h-12 rounded-full"
                  src={profilePhoto}
                  alt="profile-photo"
                />
                <div className="flex flex-col justify-start items-start">
                  <h1 className="text-2xl font-bold text-gray-900">Templates</h1>
                  <p className="text-sm text-gray-500">
                    Manage your website templates
                  </p>
                </div>
              </div>
              <div className="flex flex-row justify-end items-center gap-4">
                <Link
                  to="/templates/add"
                  className="px-4 py-2 bg-ui-blue text-white rounded-lg hover:bg-blue-700 transition-colors"
                >
                  Add New Template
                </Link>
              </div>
            </div>

            {/* Templates List Section */}

            <div className="w-full flex flex-row flex-wrap justify-start items-center gap-5 mt-10">
              {templateList.map((template) => {
                const templateID = template.pk.replace("template-", "");
                return (
                  <div
                    key={templateID}
                    className="flex flex-col"
                    title={template.template_name}
                  >
                    <Link to={`/templates/${templateID}`}>
                      <img
                        className="w-[250px] h-[200px] rounded-[9px] object-cover"
                        src={template.template_thumbnail}
                        alt="template-thumbnail"
                      />
                    </Link>
                    <div className="flex justify-end items-center -mt-[26px] rounded-b-[9px] px-2 bg-section-card">
                      <a
                        href={`https://${template.template_slug}.grigora.app`}
                        target="_blank"
                        rel="noreferrer"
                      >
                        <LinkIcon className="text-white" />
                      </a>
                    </div>
                  </div>
                );
              })}
            </div>
          </div>
        </div>
      )}
    </>
  );
}

export default Templates;
